var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownIcon = function SvgDownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "down-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.003,
    height: 8.891
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.582.414a1.423 1.423 0 0 0-2.007 0L7.466 5.452 2.428.414A1.424 1.424 0 1 0 .421 2.435L6.455 8.47a1.423 1.423 0 0 0 2.021 0l6.106-6.035a1.423 1.423 0 0 0 0-2.021Z"
  })));
};
export default SvgDownIcon;